import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export const AU_STATES = ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"];

export const CONTACT_OPTIONS = [
  ["email", "Has email"], ["no_email", "No email"], ["abn", "Has ABN"], ["no_abn", "No ABN"],
  ["phone", "Has phone"], ["no_phone", "No phone"], ["website", "Has website"], ["no_website", "No website"],
];

// options: [[value, label, count]]; "" means all
export function FilterSelect({ label, value, onChange, options, allLabel = "All", allCount, testid }) {
  return (
    <div className="space-y-1 min-w-[150px] flex-1 sm:flex-none">
      <p className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</p>
      <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
        <SelectTrigger className="h-9 w-full sm:w-[180px]" data-testid={testid}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all" data-testid={`${testid}-all`}>{allLabel}{allCount != null ? ` (${allCount})` : ""}</SelectItem>
          {options.map(([v, l, n]) => (
            <SelectItem key={v} value={v} data-testid={`${testid}-${v}`}>{l}{n != null ? ` (${n})` : ""}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
